import { createClient } from "@supabase/supabase-js";

const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;

const supabase = createClient(supabaseUrl, anonKey);

export default supabase;
